import React from "react";
import { toast } from "react-toastify";
import GMSBorderlessButton from "../../../Common/components/GMSBorderlessButton";
import Label from "../../../Common/components/Label";

const ChannelPreview = ({
  channelResponse,
  setShowChannel,
  setShowBuilder,
  setMerchantKey,
  platformInfo,
  setToken,
}) => {
  return (
    <React.Fragment>
      <div
        className="bg-white container ps-0"
        style={{
          top: "60px",
          width: "34%",
          right: "-25px",
          bottom: "0px",
          overflowY: "scroll",
          position: "fixed",
          zIndex: 3,
          boxShadow: "0 2px 4px 0 rgba(116, 116, 116, 0.15)",
        }}
      >
        <div className="">
          <div
            className="border-bottom d-flex justify-content-between pe-3 ps-3"
            style={{
              height: "65px",
            }}
          >
            <span className="align-self-center fs-5 fw-bold mb-0 pt-2">
              Channels
            </span>
            <button
              className="align-self-center border-0 btn fw fw-light mb-1 me-1 shadow-none"
              onClick={() => {
                setShowChannel((prev) => (prev = !prev));
              }}
            >
              <img
                className="promotion-close-icon mt-3"
                src={process.env.PUBLIC_URL + "/img/new-close-icon.svg"}
                alt="Close icon"
              />
            </button>
          </div>
        </div>
        <div className="p-3">
          {channelResponse &&
            channelResponse.map((item, index) => {
              return (
                <div key={item?.key} className="card mt-2">
                  <div className="d-flex justify-content-between">
                    <div className="">
                      <Label message={item.name} fontSize={"1"} />
                      <div className="mt-2">
                        <input
                          className="rounded-checkbox"
                          type="checkbox"
                          id="active"
                          onChange={(e) => null}
                          checked={true}
                        />
                        &nbsp;&nbsp;
                        <label
                          className="pb-1"
                          style={{
                            fontWeight: "400",
                            fontFamily: "Noto Sans",
                          }}
                        >
                          Apply Inventory
                        </label>
                      </div>
                    </div>
                    <div style={{ alignSelf: "center" }}>
                      <GMSBorderlessButton
                        name="Launch Preview"
                        onClick={() => {
                          if (platformInfo.get(item.key)) {
                            setMerchantKey(item.key);
                            setToken(platformInfo.get(item.key));
                            setShowBuilder((prev) => (prev = !prev));
                            setShowChannel((prev) => (prev = !prev));
                          } else {
                            toast.error(
                              "Invalid token, please try with other channels"
                            );
                          }
                        }}
                      />
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </React.Fragment>
  );
};
export default ChannelPreview;
